module.exports = __webpack_public_path__ + "img/copper-degraded.74d2bfcf.png";